import { useEffect, useState } from 'react';
import { ArrowLeft, Printer } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { loadCertificate } from '../lib/certificates';
import type { MyCertificate } from '../lib/certificates';
import { Button, ErrorState, LoadingState } from '../components/ui';

export function StudentCertificatePrint() {
  const { certificateId = '' } = useParams();
  const [cert, setCert] = useState<MyCertificate>();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    void loadCertificate(certificateId)
      .then((row) => { if (active && row) setCert(row); else if (active) setFailed(true); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [certificateId]);

  if (!cert && !failed) return <LoadingState />;
  if (failed || !cert) return <div className="utility-page"><ErrorState onRetry={() => window.location.reload()} /></div>;

  const learner = cert.LearnerName || 'AyurGuide learner';
  const courseTitle = cert.courseTitle ?? cert.CourseTitleSnapshot ?? 'AyurGuide course';
  return <div className="certificate-page">
    <div className="print-toolbar no-print">
      <Link className="back-link" to="/certificates"><ArrowLeft size={17} /> Certificates</Link>
      <Button icon={Printer} onClick={() => window.print()}>Print / save as PDF</Button>
    </div>
    <article className="certificate-sheet" aria-label="Course completion certificate">
      <header className="cert-brand"><img src="/ayurguide-logo.png" alt="" /><span>AyurGuide</span></header>
      <p className="cert-kicker">Certificate of Completion</p>
      <h1>{learner}</h1>
      <p className="cert-body">has successfully completed all lectures of the course</p>
      <h2>{courseTitle}</h2>
      <footer className="cert-foot">
        <div><strong>{formatDate(cert.issuedAt)}</strong><span>Date of issue</span></div>
        <div className="cert-seal"><img src="/ayurguide-logo.png" alt="" /><span>AyurGuide seal</span></div>
        <div><strong>{cert.CertificateId}</strong><span>Certificate ID</span></div>
      </footer>
    </article>
    <p className="cert-note no-print">Verify this certificate with its ID against AyurGuide records.</p>
  </div>;
}

function formatDate(value?: string) {
  return value ? new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : '—';
}
